import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutBrandNodes = function useLoggedOutBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutBrandNodes = {
    L1: {
      Account: strictLocalize({
        id: "7flPEZ",
        defaultMessage: [{
          "type": 0,
          "value": "Definições da conta (por exemplo, atualizar e-mail, informações bancárias)"
        }]
      }),
      Catalog: strictLocalize({
        id: "PewJ+O",
        defaultMessage: [{
          "type": 0,
          "value": "Catálogo e informações da loja"
        }]
      }),
      Disputes: strictLocalize({
        id: "Sb6ix0",
        defaultMessage: [{
          "type": 0,
          "value": "Disputas"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Faturas e pagamentos"
        }]
      }),
      Orders: strictLocalize({
        id: "lour39",
        defaultMessage: [{
          "type": 0,
          "value": "Encomendas e processamento"
        }]
      }),
      UpdateCommission: strictLocalize({
        id: "9/FL8z",
        defaultMessage: [{
          "type": 0,
          "value": "Atualizar comissão/relação"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Questões gerais de envio"
        }]
      }),
      Other: strictLocalize({
        id: "anUKfs",
        defaultMessage: [{
          "type": 0,
          "value": "Outros problemas da marca"
        }]
      })
    },
    L2: {
      SWF: strictLocalize({
        id: "xc/zXa",
        defaultMessage: [{
          "type": 0,
          "value": "Enviar com a Faire"
        }]
      }),
      SOYO: strictLocalize({
        id: "R22FJg",
        defaultMessage: [{
          "type": 0,
          "value": "Enviar por conta própria"
        }]
      }),
      SellingInternational: strictLocalize({
        id: "vNJE8v",
        defaultMessage: [{
          "type": 0,
          "value": "Vendas internacionais"
        }]
      }),
      Other: strictLocalize({
        id: "+c3AoM",
        defaultMessage: [{
          "type": 0,
          "value": "Outras perguntas"
        }]
      })
    },
    L3: {
      Availability: strictLocalize({
        id: "UaBkUO",
        defaultMessage: [{
          "type": 0,
          "value": "O envio da Faire está disponível no meu país?"
        }]
      }),
      LabelIssues: strictLocalize({
        id: "1HdGkw",
        defaultMessage: [{
          "type": 0,
          "value": "Problemas com etiquetas"
        }]
      }),
      Costs: strictLocalize({
        id: "oQXdAP",
        defaultMessage: [{
          "type": 0,
          "value": "Custos"
        }]
      }),
      Others: strictLocalize({
        id: "IwX/dA",
        defaultMessage: [{
          "type": 0,
          "value": "Outros(as)"
        }]
      }),
      HowTo: strictLocalize({
        id: "ayEfYp",
        defaultMessage: [{
          "type": 0,
          "value": "Como fazer?"
        }]
      })
    }
  };
  return loggedOutBrandNodes;
};